import { ActionReducer, Action } from '@ngrx/store';

export interface AppState {
  user: any;
  theme: any;
  filter: any;
}

const STATE_KEYS = ['user', 'theme', 'filter'];
const STORAGE_KEY_PREFIX = 'myApp_';

export function localStorageMetaReducer(
  reducer: ActionReducer<AppState>
): ActionReducer<AppState> {
  return (state: AppState | undefined, action: Action): AppState => {
    // Initialize state from localStorage on app startup
    if (state === undefined) {
      const initialState = {} as AppState;
      
      // Check if we're in a browser environment
      if (typeof window !== 'undefined' && window.localStorage) {
        STATE_KEYS.forEach(key => {
          const storageKey = `${STORAGE_KEY_PREFIX}${key}`;
          try {
            const storedValue = localStorage.getItem(storageKey);
            
            if (storedValue) {
              initialState[key as keyof AppState] = JSON.parse(storedValue);
            }
          } catch (error) {
            console.warn(`Failed to parse stored state for key: ${key}`, error);
          }
        });
      }
      
      state = initialState;
    }

    // Run the reducer
    const nextState = reducer(state, action);

    // Save updated state to localStorage
    if (nextState && typeof window !== 'undefined' && window.localStorage) {
      STATE_KEYS.forEach(key => {
        const stateSlice = nextState[key as keyof AppState];
        if (stateSlice !== undefined) {
          const storageKey = `${STORAGE_KEY_PREFIX}${key}`;
          try {
            localStorage.setItem(storageKey, JSON.stringify(stateSlice));
          } catch (error) {
            console.warn(`Failed to save state to localStorage for key: ${key}`, error);
          }
        }
      });
    }

    return nextState;
  };
}
